import { render, staticRenderFns } from "./ChatOrderFreeProduct.vue?vue&type=template&id=bd1fd0fe&scoped=true&"
import script from "./ChatOrderFreeProduct.vue?vue&type=script&lang=js&"
export * from "./ChatOrderFreeProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1fd0fe",
  null
  
)

export default component.exports